import React from 'react';
import privacyData from '../privacy.json';
import { Helmet } from 'react-helmet';

function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - CoPilot Prompt Generator</title>
        <meta name="description" content="Privacy Policy for Microsoft Copilot Prompt Generator" />
      </Helmet>
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">{privacyData.title}</h1>
          
          <p className="text-gray-600 mb-6">{privacyData.introduction}</p>
          
          {privacyData.sections.map((section, index) => (
            <div key={index} className="mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">{section.title}</h3>
              
              {section.items ? (
                <ul className="list-disc pl-5 space-y-3">
                  {section.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-gray-600">
                      <span className="font-medium text-gray-700">{item.name}:</span> {item.description}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-600">{section.description}</p>
              )}
            </div>
          ))}

          <p className="text-sm text-gray-500 mt-6">
            Effective Date: {privacyData.effective_date}
          </p>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy; 